<template>
  <div class="teacher-home-wrapper">
    <van-nav-bar
      :class="['nav', {'transparent': isTransparent}]"
      fixed
      placeholder
      @click-left="$router.push({name: 'studio-teachers'})"
    >
      <template #left>
        <span class="left">
          <van-icon name="arrow-left" /> 返回首页
        </span>
      </template>
    </van-nav-bar>
    <teacher-item float :item="item" />
    <teacher-tabbar />
    <div v-if="item.introduction" class="introduction-wrapper">
      {{ item.introduction }}
    </div>
    <div class="detail">
      <template v-for="(detail, index) in item.detail">
        <teacher-detail-item
          :key="index"
          :detail="detail"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { TeacherItem, TeacherDetailItem } from '@/components/item'
import TeacherTabbar from '@/components/tabbar/TeacherTabbar'
import { Teacher } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'TeacherHome',
  components: { TeacherItem, TeacherDetailItem, TeacherTabbar },
  mixins: [mixinWxShare],
  data: () => ({
    scrollTop: null,
    item: {
      details: []
    }
  }),
  computed: {
    isTransparent () {
      return this.scrollTop <= 0
    }
  },
  async mounted () {
    try {
      const { teacherId } = this.$route.params
      const { teacher: item } = await Teacher.detail({ teacherId })
      this.item = item
      window.addEventListener('scroll', this.scrollCal)
    } catch (error) {
      console.log(error)
    }
  },
  beforDestroy () {
    window.removeEventListener('scroll', this.scrollCal)
  },
  methods: {
    scrollCal () {
      this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-home-wrapper {
  @include bg-image-png('/teacher/home-bg');
  @include mh-bgc(100vh, #fff);
  background-size: 100% 100vh;
  background-attachment: fixed;
  background-position: left top;
  padding: 15px 16px;
  overflow: hidden;
  .nav {
    &.transparent::v-deep {
      .van-nav-bar {
        background-color: transparent;
        &::after {
          border-color: transparent;
        }
      }
    }
    .left {
      @include sc($font-size-lg, $color-text-medium);
      .van-icon {
        @include sc($font-size-xlg, $color-text-medium);
        vertical-align: sub;
      }
    }
  }
  .introduction-wrapper {
    @include wh(100%, initial);
    @include sc($font-size-base, $color-text-light);
    @include lw(18px);
    white-space: break-spaces;
    padding: 15px 15px 15px 89px;
    border-radius: 4px;
    background-color: #fff;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);
    margin-top: 24px;
    position: relative;
    &::before {
      @include wh(69px, 61px);
      @include bg-image-png('/teacher/comma');
      content: " ";
      position: absolute;
      left: 10px;
      top: -10px;
      background-size: cover;
    }
  }
  .detail {
    margin-top: 24px;
  }
}
</style>
